// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-calendar {
    width: 350px;
    max-width: 100%;
    background: white;
    border: 1px solid #a0a096;
    font-family: 'Arial', 'Helvetica', sans-serif;
    line-height: 1.125em;
  }
  
  .react-calendar--doubleView {
    width: 700px;
  }
  
  .react-calendar--doubleView .react-calendar__viewContainer {
    display: flex;
    margin: -0.5em;
  }
  
  .react-calendar--doubleView .react-calendar__viewContainer > * {
    width: 50%;
    margin: 0.5em;
  }
  
  .react-calendar,
  .react-calendar *,
  .react-calendar *:before,
  .react-calendar *:after {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  
  .react-calendar button {
    margin: 0;
    border: 0;
    outline: none;
  }
  
  .react-calendar button:enabled:hover {
    cursor: pointer;
  }
  
  .react-calendar__navigation {
    display: flex;
    height: 44px;
    margin-bottom: 1em;
  }
  
  .react-calendar__navigation button {
    min-width: 44px;
    background: none;
  }
  
  .react-calendar__navigation button:disabled {
    background-color: #f0f0f0;
  }
  
  .react-calendar__navigation button:enabled:hover,
  .react-calendar__navigation button:enabled:focus {
    background-color: #e6e6e6;
  }
  
  .react-calendar__month-view__weekdays {
    text-align: center;
    text-transform: uppercase;
    font: inherit;
    font-size: 0.75em;
    font-weight: bold;
  }
  
  .react-calendar__month-view__weekdays__weekday {
    padding: 0.5em;
  }
  
  .react-calendar__month-view__weekNumbers .react-calendar__tile {
    display: flex;
    align-items: center;
    justify-content: center;
    font: inherit;
    font-size: 0.75em;
    font-weight: bold;
  }
  
  .react-calendar__month-view__days__day--weekend {
    color: #d10000;
  }
  
  .react-calendar__month-view__days__day--neighboringMonth,
  .react-calendar__decade-view__years__year--neighboringDecade,
  .react-calendar__century-view__decades__decade--neighboringCentury {
    color: #757575;
  }
  
  .react-calendar__year-view .react-calendar__tile,
  .react-calendar__decade-view .react-calendar__tile,
  .react-calendar__century-view .react-calendar__tile {
    padding: 2em 0.5em;
  }
  
  .react-calendar__tile {
    max-width: 100%;
    padding: 10px 6.6667px;
    background: none;
    text-align: center;
    font: inherit;
    font-size: 0.833em;
  }
  
  .react-calendar__tile:disabled {
    background-color: #f0f0f0;
    color: #ababab;
  }
  
  .react-calendar__month-view__days__day--neighboringMonth:disabled,
  .react-calendar__decade-view__years__year--neighboringDecade:disabled,
  .react-calendar__century-view__decades__decade--neighboringCentury:disabled {
    color: #cdcdcd;
  }
  
  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus {
    background-color: #e6e6e6;
  }
  
  .react-calendar__tile--now {
    background: #ffff76;
  }
  
  .react-calendar__tile--now:enabled:hover,
  .react-calendar__tile--now:enabled:focus {
    background: #ffffa9;
  }
  
  .react-calendar__tile--hasActive {
    background: #76baff;
  }
  
  .react-calendar__tile--hasActive:enabled:hover,
  .react-calendar__tile--hasActive:enabled:focus {
    background: #a9d4ff;
  }
  
  .react-calendar__tile--active {
    background: #006edc;
    color: white;
  }
  
  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus {
    background: #1087ff;
  }
  
  .react-calendar--selectRange .react-calendar__tile--hover {
    background-color: #e6e6e6;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/details/pages/agenda/Calendar.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,6CAA6C;IAC7C,oBAAoB;EACtB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;;;;IAIE,2BAA2B;IAC3B,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,SAAS;IACT,SAAS;IACT,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;;;IAGE,cAAc;EAChB;;EAEA;;;IAGE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;;;IAGE,cAAc;EAChB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".react-calendar {\r\n    width: 350px;\r\n    max-width: 100%;\r\n    background: white;\r\n    border: 1px solid #a0a096;\r\n    font-family: 'Arial', 'Helvetica', sans-serif;\r\n    line-height: 1.125em;\r\n  }\r\n  \r\n  .react-calendar--doubleView {\r\n    width: 700px;\r\n  }\r\n  \r\n  .react-calendar--doubleView .react-calendar__viewContainer {\r\n    display: flex;\r\n    margin: -0.5em;\r\n  }\r\n  \r\n  .react-calendar--doubleView .react-calendar__viewContainer > * {\r\n    width: 50%;\r\n    margin: 0.5em;\r\n  }\r\n  \r\n  .react-calendar,\r\n  .react-calendar *,\r\n  .react-calendar *:before,\r\n  .react-calendar *:after {\r\n    -moz-box-sizing: border-box;\r\n    -webkit-box-sizing: border-box;\r\n    box-sizing: border-box;\r\n  }\r\n  \r\n  .react-calendar button {\r\n    margin: 0;\r\n    border: 0;\r\n    outline: none;\r\n  }\r\n  \r\n  .react-calendar button:enabled:hover {\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .react-calendar__navigation {\r\n    display: flex;\r\n    height: 44px;\r\n    margin-bottom: 1em;\r\n  }\r\n  \r\n  .react-calendar__navigation button {\r\n    min-width: 44px;\r\n    background: none;\r\n  }\r\n  \r\n  .react-calendar__navigation button:disabled {\r\n    background-color: #f0f0f0;\r\n  }\r\n  \r\n  .react-calendar__navigation button:enabled:hover,\r\n  .react-calendar__navigation button:enabled:focus {\r\n    background-color: #e6e6e6;\r\n  }\r\n  \r\n  .react-calendar__month-view__weekdays {\r\n    text-align: center;\r\n    text-transform: uppercase;\r\n    font: inherit;\r\n    font-size: 0.75em;\r\n    font-weight: bold;\r\n  }\r\n  \r\n  .react-calendar__month-view__weekdays__weekday {\r\n    padding: 0.5em;\r\n  }\r\n  \r\n  .react-calendar__month-view__weekNumbers .react-calendar__tile {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font: inherit;\r\n    font-size: 0.75em;\r\n    font-weight: bold;\r\n  }\r\n  \r\n  .react-calendar__month-view__days__day--weekend {\r\n    color: #d10000;\r\n  }\r\n  \r\n  .react-calendar__month-view__days__day--neighboringMonth,\r\n  .react-calendar__decade-view__years__year--neighboringDecade,\r\n  .react-calendar__century-view__decades__decade--neighboringCentury {\r\n    color: #757575;\r\n  }\r\n  \r\n  .react-calendar__year-view .react-calendar__tile,\r\n  .react-calendar__decade-view .react-calendar__tile,\r\n  .react-calendar__century-view .react-calendar__tile {\r\n    padding: 2em 0.5em;\r\n  }\r\n  \r\n  .react-calendar__tile {\r\n    max-width: 100%;\r\n    padding: 10px 6.6667px;\r\n    background: none;\r\n    text-align: center;\r\n    font: inherit;\r\n    font-size: 0.833em;\r\n  }\r\n  \r\n  .react-calendar__tile:disabled {\r\n    background-color: #f0f0f0;\r\n    color: #ababab;\r\n  }\r\n  \r\n  .react-calendar__month-view__days__day--neighboringMonth:disabled,\r\n  .react-calendar__decade-view__years__year--neighboringDecade:disabled,\r\n  .react-calendar__century-view__decades__decade--neighboringCentury:disabled {\r\n    color: #cdcdcd;\r\n  }\r\n  \r\n  .react-calendar__tile:enabled:hover,\r\n  .react-calendar__tile:enabled:focus {\r\n    background-color: #e6e6e6;\r\n  }\r\n  \r\n  .react-calendar__tile--now {\r\n    background: #ffff76;\r\n  }\r\n  \r\n  .react-calendar__tile--now:enabled:hover,\r\n  .react-calendar__tile--now:enabled:focus {\r\n    background: #ffffa9;\r\n  }\r\n  \r\n  .react-calendar__tile--hasActive {\r\n    background: #76baff;\r\n  }\r\n  \r\n  .react-calendar__tile--hasActive:enabled:hover,\r\n  .react-calendar__tile--hasActive:enabled:focus {\r\n    background: #a9d4ff;\r\n  }\r\n  \r\n  .react-calendar__tile--active {\r\n    background: #006edc;\r\n    color: white;\r\n  }\r\n  \r\n  .react-calendar__tile--active:enabled:hover,\r\n  .react-calendar__tile--active:enabled:focus {\r\n    background: #1087ff;\r\n  }\r\n  \r\n  .react-calendar--selectRange .react-calendar__tile--hover {\r\n    background-color: #e6e6e6;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
